const defaultTool = [
  {
    '@type': 'HowToTool',
    name: 'Computer'
  },
  {
    '@type': 'HowToTool',
    name: 'Tablet'
  },
  {
    '@type': 'HowToTool',
    name: 'Mobile'
  }
]
const defaultSupply = [
  {
    '@type': 'HowToSupply',
    name: 'Website'
  },
  {
    '@type': 'HowToSupply',
    name: 'Internet connection'
  }
]
const schemaTypes = {
  HowToStep: ['name', 'image', 'text'],
  HowToSupply: ['name'],
  HowToTool: ['name']
}

export function constructHowToSchema (schema) {
  const formatSchema = (array, type) =>
    Array.isArray(array) &&
    array.map((props) => {
      const obj = {
        '@type': type
      }
      Object.entries(props).forEach(([key, value]) => {
        if (schemaTypes[type].includes(key) && value) {
          obj[key] = value
        }
      })
      return obj
    })
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: schema.name,
    image: schema.image,
    totalTime: schema.totalTime || 'PT2H30M',
    step: formatSchema(schema.step, 'HowToStep'),
    tool: schema.tool ? formatSchema(schema.tool, 'HowToTool') : defaultTool,
    supply: schema.supply
      ? formatSchema(schema.supply, 'HowToSupply')
      : defaultSupply
  }
  return JSON.stringify(baseSchema)
}
